<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <BankForm v-if="bank" :bank="bank" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import BankForm from '@/components/settings/test-registers/bank/BankForm.vue'

export default {
  name: 'BankFormEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    BankForm
  },
  computed: {
    ...mapState({
      bank: state => state.banks.bankById
    })
  },
  methods: {
    ...mapActions('banks', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }

}

</script>
